import { render } from "./WelcomePage.vue?vue&type=template&id=9fd6cd32&scoped=true"
const script = {}

import "./WelcomePage.vue?vue&type=style&index=0&id=9fd6cd32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd6cd32"]])

export default __exports__